import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'The Complete Basetao Spreadsheet Guide',
    desc: 'Master smart shopping with our comprehensive guide covering all 14 product categories, shipping strategies, and money-saving tips.',
    to: '/article/basetao-spreadsheet-guide',
    tag: 'Guide',
    readTime: '15 min',
    icon: 'ri-book-open-line',
  },
  {
    title: 'Basetao Review 2026',
    desc: 'In-depth analysis of Basetao features, pricing, shipping options, and overall user experience to help you decide if it is right for you.',
    to: '/article/basetao-review',
    tag: 'Review',
    readTime: '12 min',
    icon: 'ri-star-line',
  },
  {
    title: 'Is Basetao Legit and Safe?',
    desc: 'A deep dive into Basetao trustworthiness, payment security, buyer protection policies, and real user feedback from the community.',
    to: '/article/is-basetao-legit',
    tag: 'Safety',
    readTime: '10 min',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Basetao Shipping Cost Guide',
    desc: 'Complete breakdown of shipping rates by carrier and destination, plus proven strategies to reduce your shipping expenses.',
    to: '/article/basetao-shipping-cost',
    tag: 'Shipping',
    readTime: '11 min',
    icon: 'ri-ship-line',
  },
  {
    title: 'Basetao Coupon & Discount Codes',
    desc: 'Find the latest Basetao coupon codes, seasonal promotions, and advanced strategies to maximize your savings on every order.',
    to: '/article/basetao-coupon-guide',
    tag: 'Savings',
    readTime: '8 min',
    icon: 'ri-coupon-line',
  },
  {
    title: 'Basetao Warehouse & QC Photos Guide',
    desc: 'Everything about warehouse storage, QC photo inspection, package consolidation, and expert tips for managing your items.',
    to: '/article/basetao-warehouse-guide',
    tag: 'Warehouse',
    readTime: '9 min',
    icon: 'ri-archive-line',
  },
  {
    title: 'Basetao vs Superbuy Comparison',
    desc: 'Side-by-side comparison of pricing, features, shipping, and user experience to find the best agent for your needs.',
    to: '/article/basetao-vs-superbuy',
    tag: 'Comparison',
    readTime: '10 min',
    icon: 'ri-scales-3-line',
  },
  {
    title: 'How to Use Basetao: Beginner Guide',
    desc: 'Step-by-step tutorial for first-time users covering account setup, product submission, payments, QC photos, and shipping.',
    to: '/article/basetao-beginner-guide',
    tag: 'Beginner',
    readTime: '12 min',
    icon: 'ri-user-smile-line',
  },
  {
    title: 'Basetao Spreadsheet Tutorial',
    desc: 'Learn how to navigate product find spreadsheets, filter by category, compare prices, and discover items faster than manual browsing.',
    to: '/article/basetao-spreadsheet-tutorial',
    tag: 'Tutorial',
    readTime: '9 min',
    icon: 'ri-search-eye-line',
  },
  {
    title: 'Basetao Alternatives Compared',
    desc: 'Explore 7 top Chinese shopping agents including Superbuy, Sugargoo, Wegobuy, and Pandabuy with detailed feature comparisons.',
    to: '/article/basetao-alternatives',
    tag: 'Alternatives',
    readTime: '11 min',
    icon: 'ri-stack-line',
  },
  {
    title: 'Basetao Buying Guide: Expert Tips',
    desc: 'Master the art of smart purchasing with strategies for choosing sellers, verifying quality, avoiding scams, and managing sizing.',
    to: '/article/basetao-buying-guide',
    tag: 'Buying',
    readTime: '10 min',
    icon: 'ri-shopping-bag-line',
  },
];

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">Knowledge Base</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
            Basetao Spreadsheet Guides & Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our collection of in-depth articles covering everything from beginner tutorials to advanced buying strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.to}
              to={article.to}
              className="group flex flex-col p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600 group-hover:bg-accent-200 transition-colors">
                  <i className={`${article.icon} text-base`}></i>
                </div>
                <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">{article.tag}</span>
                <span className="text-xs text-foreground-400">{article.readTime}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-grow">
                {article.desc}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                Read Article
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}